import { PublicClientApplication } from "@azure/msal-browser";
import { getEnvValue } from "./utils/helpers";
import { EnvKeys } from "./utils/consts";

export const msalInstance = new PublicClientApplication({
	// TODO: Update to use env values
	auth: {
		clientId: getEnvValue(EnvKeys.AzureClientId),
		authority: `https://login.microsoftonline.com/${getEnvValue(EnvKeys.AzureTenantId)}`,
		redirectUri: `${window.location.origin}/auth/callback`,
		postLogoutRedirectUri: window.location.origin,
		navigateToLoginRequestUrl: false
	},
	cache: {
		cacheLocation: "sessionStorage" // XSS-resistant
	}
});
